import { CliIcon } from "@icons";
import adpLogo from "@icons/institutions/adp.svg";
import benchLogo from "@icons/institutions/bench.svg";
import billLogo from "@icons/institutions/bill.svg";
import chatgptLogo from "@icons/institutions/chatgpt.svg";
import claudeLogo from "@icons/institutions/claude.svg";
import copilotLogo from "@icons/institutions/copilot.svg";
import cursorLogo from "@icons/institutions/cursor.svg";
import geminiLogo from "@icons/institutions/gemini.svg";
import googleSheetsLogo from "@icons/institutions/google-sheets.png";
import googleLogo from "@icons/institutions/google.svg";
import grokLogo from "@icons/institutions/grok.svg";
import gustoLogo from "@icons/institutions/gusto.svg";
import KickMark from "@icons/institutions/kick.svg?react";
import mcpLogo from "@icons/institutions/mcp.svg";
import paychexLogo from "@icons/institutions/paychex.svg";
import perplexityLogo from "@icons/institutions/perplexity.svg";
import quickbooksLogo from "@icons/institutions/quickbooks.svg";
import rampLogo from "@icons/institutions/ramp.svg";
import type { InstitutionArtwork } from "./institutionArtwork";

// ds-deviation: brand colour. Container fills without a matching token are
// brand data, kept as the hex Figma draws (spec I8).

/** Figma's Kick, payroll, spend, accounting, Google and AI brands. */
export const providerInstitutions = {
    kick: {
        name: "Kick",
        background: "var(--fg-primary)",
        glyph: { Glyph: KickMark, color: "var(--fg-on-solid)" },
        box: { x: 9.56, y: 11.91, width: 20.32, height: 16.18 },
    },
    gusto: {
        name: "Gusto",
        background: "#f45d48",
        glyph: { src: gustoLogo },
        box: { x: 4, y: 14, width: 32, height: 12.17 },
    },
    ramp: {
        name: "Ramp",
        background: "#e4f223",
        glyph: { src: rampLogo },
        box: { x: 9, y: 9, width: 22, height: 18.87 },
    },
    bill: {
        name: "Bill",
        background: "#ff5a0a",
        glyph: { src: billLogo },
        box: { x: 8, y: 12, width: 24, height: 15.6 },
    },
    quickbooks: {
        name: "QuickBooks",
        background: "#2ca01c",
        glyph: { src: quickbooksLogo },
    },
    adp: {
        name: "ADP",
        background: "#cf4037",
        glyph: { src: adpLogo },
        box: { x: 4, y: 13, width: 32, height: 14.59 },
    },
    paychex: {
        name: "Paychex",
        background: "#004b8d",
        glyph: { src: paychexLogo },
        box: { x: 2, y: 2, width: 36, height: 36 },
    },
    bench: {
        name: "Bench",
        glyph: { src: benchLogo },
        box: { x: 7.89, y: 9.58, width: 24.21, height: 24.21 },
    },
    google: {
        name: "Google",
        glyph: { src: googleLogo },
        box: { x: 7.96, y: 7.96, width: 24.08, height: 24.08 },
    },
    "google-sheets": {
        name: "Google Sheets",
        glyph: { src: googleSheetsLogo },
        box: { x: 5, y: 9.09, width: 30, height: 21.82 },
    },
    mcp: {
        name: "MCP",
        background: "var(--color-midnight-gray-900)",
        glyph: { src: mcpLogo },
        box: { x: 7.87, y: 6.61, width: 24.13, height: 26.85 },
    },
    claude: {
        name: "Claude",
        background: "#d97757",
        glyph: { src: claudeLogo },
        box: { x: 5, y: 5, width: 29.98, height: 30 },
    },
    chatgpt: {
        name: "ChatGPT",
        background: "var(--color-black)",
        glyph: { src: chatgptLogo },
        box: { x: 5.19, y: 5, width: 29.61, height: 30 },
    },
    cursor: {
        name: "Cursor",
        background: "var(--color-black)",
        glyph: { src: cursorLogo },
        box: { x: 6, y: 4, width: 28, height: 31.99 },
    },
    cli: {
        name: "CLI",
        background: "var(--color-black)",
        glyph: { Glyph: CliIcon, color: "var(--color-white)" },
        box: { x: 7, y: 7, width: 26, height: 26 },
    },
    grok: {
        name: "Grok",
        background: "var(--color-black)",
        glyph: { src: grokLogo },
        box: { x: 6.46, y: 7, width: 27.08, height: 26 },
    },
    perplexity: {
        name: "Perplexity",
        background: "#20808d",
        glyph: { src: perplexityLogo },
        box: { x: 7.56, y: 4.08, width: 24.88, height: 31.83 },
    },
    gemini: {
        name: "Gemini",
        background: "var(--color-white)",
        glyph: { src: geminiLogo },
    },
    copilot: {
        name: "Copilot",
        background: "var(--color-white)",
        glyph: { src: copilotLogo },
        box: { x: 4, y: 4, width: 32, height: 32 },
    },
} satisfies Record<string, InstitutionArtwork>;
